var _circle, _circle2, _circle3, _g, _circle4, _circle5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_85)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9751,
    cy: 49.9751,
    r: 25.9751,
    fill: "#393184"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9752,
    cy: 49.9748,
    r: 20.5636,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7304 46.0326L27.4444 46.2067C24.5771 50.1535 27.1898 55.706 28.8546 57.9889C35.0595 55.0172 39.5877 57.5246 41.0763 59.1497C45.9179 63.0036 44.9739 68.9198 43.8966 71.3962C47.8922 73.7643 53.9051 72.3829 56.4121 71.3962C53.7327 65.5922 57.1759 60.8135 59.2324 59.1497C63.275 55.4351 69.0254 56.7507 71.3953 57.8728C74.6858 54.5761 73.6673 48.6831 72.7467 46.1487L66.6947 46.0326C62.6992 46.2184 59.35 44.2914 58.1748 43.3047C55.2604 39.7759 51.7114 39.1258 50.3012 39.2419C46.3997 39.0097 43.2307 41.8537 42.1339 43.3047C39.2195 45.6728 35.9839 46.11 34.7304 46.0326Z",
    fill: "url(#paint1_linear_1062_85)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7304 46.0326L27.4444 46.2067C24.5771 50.1535 27.1898 55.706 28.8546 57.9889C35.0595 55.0172 39.5877 57.5246 41.0763 59.1497C45.9179 63.0036 44.9739 68.9198 43.8966 71.3962C47.8922 73.7643 53.9051 72.3829 56.4121 71.3962C53.7327 65.5922 57.1759 60.8135 59.2324 59.1497C63.275 55.4351 69.0254 56.7507 71.3953 57.8728C74.6858 54.5761 73.6673 48.6831 72.7467 46.1487L66.6947 46.0326C62.6992 46.2184 59.35 44.2914 58.1748 43.3047C55.2604 39.7759 51.7114 39.1258 50.3012 39.2419C46.3997 39.0097 43.2307 41.8537 42.1339 43.3047C39.2195 45.6728 35.9839 46.11 34.7304 46.0326Z",
    stroke: "url(#paint2_linear_1062_85)",
    strokeWidth: 0.5
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9085,
    cy: 51.2948,
    r: 5.8387,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9086,
    cy: 51.2949,
    r: 1.94623,
    fill: "#393184"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_85",
    x: 24.0146,
    y: 37.0785,
    width: 51.7878,
    height: 37.7756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_85",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_85",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_85",
    x1: 31.2463,
    y1: 42.317,
    x2: 73.4662,
    y2: 73.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_85",
    x1: 53.8659,
    y1: 44.8077,
    x2: 63.4642,
    y2: 76.5788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteering);
export default __webpack_public_path__ + "static/media/steering.97e1103cd87bf6ed693df56d2c71fda3.svg";
export { ForwardRef as ReactComponent };